import { observer } from "mobx-react-lite";
import React from "react";

const ProfileImage = ({ url }) => {
  return (
    <img
      className="profile"
      src={
        url
        //UserStore.currentFamilyMembersImages?.[getCookie("userid")]
      }
      alt="profile"
    />
  );
};

export default observer(ProfileImage);
